<template>
  <div>
    <BOverlay :show="l_fullscreen_overlay" spinner-variant="primary" rounded="sm">
      <!--地図表示-->
      <BTabs content-class="mt-3" @update:modelValue="handleTabChange">
        <BTab id="routeTab" title="参考ルート" @tab-click="listenCurrentTabClick" active>
          <div id='routemap'></div>
        </BTab>
        <BTab id="routeHistoryTab" title="ルート履歴" @tab-click="listenHistoryTabClick">
          <div id='routeHistoryMap'>
            <div id="left" class="sidebar flex-center left collapsed">
              <!--選択状態-->
              <div v-if="l_selectedRouteId !== ''" class="sidebar-content rounded-rect">
                <div>
                  <div>
                    <BListGroup flush>
                      <BListGroupItem>
                        <BFormCheckbox v-model="isSymbolView" @update:modelValue="toggleHistoryRouteSymbolData">
                          時刻表示
                        </BFormCheckbox>
                      </BListGroupItem>

                      <BListGroupItem v-for="(item, index) in l_routeDataActualJSON" :key="index"
                        class="flex-column align-items-start">
                        <div class="d-flex w-100 justify-content-between" button
                          @click="toggleHistoryAccordion(`actualroutelist-accordion-${l_selectedRouteId}-${index}`); handlerHistoryRouteDisplay(item, index)">
                          <h5 class="mb-1">{{ item.date }}</h5>
                          <h5 class="cursor-pointer">
                            <BBadge variant="info" v-if="item.status === 'Active'">作業中</BBadge>
                            <BBadge variant="dark" v-else>作業終了</BBadge>
                          </h5>
                        </div>

                        <BCard class="w-100">
                          <h6>
                            <i class="bi bi-pin-map align-middle mr-2"></i>{{ item.startAt }}
                          </h6>
                          <h6>
                            <i class="bi bi-three-dots-vertical align-middle mr-2"></i>
                          </h6>
                          <h6>
                            <i class="bi bi-flag-fill align-middle mr-2"></i>{{ item.finishedAt }}
                          </h6>
                          <div v-if="isHistoryAccordionOpen(`actualroutelist-accordion-${l_selectedRouteId}-${index}`)"
                            :id="`actualroutelist-accordion-${l_selectedRouteId}-${index}`" role="tabpanel">
                            <h6>車両ID : {{ item.vehicleId }}</h6>
                            <h6>回収状態 : {{ getConvertedOperationStatus(item.status) }}</h6>
                            <h6>ステーション : {{ item.stationCurrent }}</h6>
                            <h6>企業名 : {{ item.company }}</h6>
                            <h6>回収時間 : {{ item.duration }}</h6>
                            <BButton v-if="l_route_regist_enable" @click="showRouteModal = true" class="mt-2 w-100"
                              variant="secondary">このルートを登録する</BButton>
                          </div>
                        </BCard>
                      </BListGroupItem>
                      <div v-if="l_routeHistoryLastId !== ''" class="input-inputLabel">
                        <BButton class="mypage-button" :disabled="l_routeHistoryProcessing"
                          @click="handlerShowMoerRouteHistoryDispleay">さらに表示</BButton>
                      </div>
                    </BListGroup>
                  </div>
                </div>
              </div>
              <!--未選択状態-->
              <div v-else class="sidebar-content rounded-rect flex-center">
                <h5>ルートIDを選択してください</h5>
              </div>
            </div>
          </div>

          <!--登録用カードウィンドウ-->
          <BModal
            class="newmodal"
            id="NewRouteModal"
            :show="showRouteModal"
            @show="l_routeRegisterCompleted = false"
            @hidden="initRouteId"
            @hide="showRouteModal = false">
            <template #header>
              <h5 class="newmodal">ルートの追加</h5>
            </template>
            <div class="newmodal">
              <BRow>
                <BCol>
                  <label for="newsetting-name">ルートID</label>
                  <BFormInput id="newsetting-name" v-model="l_newAdditionalRouteId"
                    :disabled="l_routeRegisterProcessing || l_routeRegisterCompleted" :state="routeIdState"
                    placeholder="5桁の数字を入力してください" />
                  <BFormInvalidFeedback id="input-live-feedback">
                    {{ l_newAdditionalRouteInfo.error }}
                  </BFormInvalidFeedback>
                </BCol>
              </BRow>
            </div>

            <!--登録用カード-->
            <BCard v-if="l_newAdditionalRouteInfoArea" class="newmodal mt-3"
              :title="'ルートID : ' + l_newAdditionalRouteId" :sub-title="'割当企業 : ' + l_newAdditionalRouteInfo.company">
              <BCardText>
                {{ l_newAdditionalRouteInfo.garbageType }}
                ({{ l_newAdditionalRouteInfo.collectionType }})
                <div>曜日:{{ l_newAdditionalRouteInfo.weekday }}</div>
              </BCardText>
              <BCardText>
                ルート番号 : {{ l_newAdditionalRouteInfo.number }}
              </BCardText>
            </BCard>

            <!--上書き確認ONS-->
            <div class="newmodal mt-1 text-center" v-if="l_routeRegisterItIsAlreadyExist && !l_routeRegisterCompleted">
              <BAlert show variant="primary">
                既存のルートID{{ l_newAdditionalRouteId }}の参考ルートが上書きされます
                本当によろしいですか？
              </BAlert>
            </div>

            <!--上書き完了ONS-->
            <div class="newmodal mt-1 text-center" v-if="l_routeRegisterItIsAlreadyExist && l_routeRegisterCompleted">
              <BAlert show variant="primary">
                ルートID{{ l_newAdditionalRouteId }}の参考ルートを上書きしました
              </BAlert>
            </div>

            <!--追加登録ボタン-->
            <BButton :disabled="l_routeRegisterProcessing || l_routeRegisterCompleted || !routeIdState"
              class="w-100 mt-2" variant="info" @click="registerRouteDetaWrapper(l_newAdditionalRouteId)">
              <div v-if="!l_routeRegisterCompleted">追加する
                <BSpinner v-if="l_routeRegisterProcessing" label="Spinning" small class="ml-2" />
              </div>
              <div v-else>完了しました</div>
            </BButton>

            <!--キャンセル用フッター-->
            <template #footer="{ close }">
              <BButton v-if="!l_routeRegisterCompleted" :disabled="l_routeRegisterProcessing" class="newmodal"
                variant="secondary" @click="close()">
                いいえ(中止します)
              </BButton>
              <BButton v-else :disabled="l_routeRegisterProcessing" class="newmodal" variant="secondary"
                @click="close()">
                閉じる
              </BButton>
            </template>
          </BModal>
        </BTab>
      </BTabs>
    </BOverlay>
  </div>
</template>
<script>
import axios from 'axios'
import moment from "moment"
// MapLibre GL JSを読み込み
import maplibregl from 'maplibre-gl'
// Amplify読み込み
import { Auth, Signer } from 'aws-amplify'
import withTimeout from './../../common/withTimeout'
//import awsconfig from '../aws-exports'
// ダッシュボード(StationMapModule)の「回収済」アイコンと統一(灰色チェックマーク)
import household_empty_image from './../../assets/icons/addIcons/trash_empty.png'
import household_full_image from './../../assets/icons/trash_household_full.png'
import recycle_empty_image from './../../assets/icons/trash_recycle_empty.png'
import recycle_full_image from './../../assets/icons/trash_recycle_full.png'
import recycle_noready_image from './../../assets/icons/trash_recycle_noready.png'
// ダッシュボード(StationMapModule)と統一する企業別色分けアイコン（家庭ごみFullステータス用）
import household_full_blue_image from './../../assets/icons/addIcons/trash_household_blue.png'
import household_full_green_image from './../../assets/icons/addIcons/trash_household_green.png'
import household_full_red_image from './../../assets/icons/addIcons/trash_household_red.png'
import household_full_yellow_image from './../../assets/icons/addIcons/trash_household_yellow.png'
import household_full_purple_image from './../../assets/icons/addIcons/trash_household_purple.png'

export default {
  props: {
    handleRefreshRoute: {
      type: Function,
      required: true
    }
  },
  name: 'RouteMapModule',
  data() {
    return {
      centerlatlon: [140.2682015729859, 38.14985690746369],
      zoom: 11,
      credentials: null,
      l_mapobject: null,
      l_mapHistoryobject: null,
      l_newAdditionalRouteId: "",
      l_companyMasterList: [],
      l_newAdditionalRouteInfo: {
        garbageType: "",
        companyId: "",
        company: "",
        weekday: "",
        weekdayType: "",
        collectionType: "",
        number: "",
        carnumber: "",
        error: ""
      },
      TAB_INDEX: {
        ROUTE: 'routeTab',
        ROUTE_HISTORY: 'routeHistoryTab'
      },
      l_newAdditionalRouteInfoArea: false,

      // View Condition Parameters
      l_refroute_display_enable: true,
      l_fullscreen_overlay: false,
      showRouteModal: false, // モーダル表示制御用

      // Geo Layer Ids
      l_selectedRouteId: '',
      l_layer_current_refroute_id: '',
      l_layer_current_histroute_id: '',
      l_layer_current_histroute_symbol_id: '',
      l_source_current_refroute_id: '',
      l_source_current_histroute_id: '',
      l_source_current_histroute_symbol_id: '',
      l_selectedHisoryRouteId: '',
      l_routeDataActualJSON: {
      },
      l_routeDataActualJSON_index: 0,
      l_routeDataReferenceJSON: {
      },
      l_routeIdListData: [],

      l_stationDataActualJSON: {},
      l_marker_current_start_point: null,
      l_marker_current_end_point: null,
      l_marker_hist_start_point: null,
      l_marker_hist_end_point: null,
      l_currentFullStationLayerData: null,
      l_currentEmptyStationLayerData: null,

      l_historyFullStationLayerData: null,
      l_historyEmptyStationLayerData: null,

      l_routeRegisterProcessing: false,
      l_routeRegisterCompleted: false,
      l_routeRegisterItIsAlreadyExist: false,
      l_routeHistoryProcessing: false,

      l_selecteGarbageType: null,
      l_selecteCollectType: null,

      l_clickCurrentMapObject: null,
      l_routeHistoryLastId: '',

      l_popUpListObject: [],
      l_route_regist_enable: true,
      isSymbolView: true,
      // Accordion state management for route history
      activeHistoryAccordionId: null,
      // companyMaster(yokkaichi-garbage-masters-dev)のdataNoと対応する家庭ごみFull時のアイコン
      // ダッシュボード(StationMapModule)のtrashMappingと同じ配色（ミツワ=blue エコリレー=green 県南=red 恭栄=yellow ドリーム=purple）
      householdFullCompanyImageMapping: {
        "0": "household_full_blue_image",
        "1": "household_full_blue_image",
        "2": "household_full_green_image",
        "3": "household_full_green_image",
        "4": "household_full_red_image",
        "5": "household_full_red_image",
        "6": "household_full_yellow_image",
        "7": "household_full_yellow_image",
        "8": "household_full_yellow_image",
        "9": "household_full_purple_image",
      },
    }
  },
  computed: {
    routeIdState() {
      var ret = false
      const regex = new RegExp(/^[0-9]+$/);
      if (regex.test(this.l_newAdditionalRouteId) && (this.l_newAdditionalRouteId.length == 5)) {
        ret = true
        this.l_newAdditionalRouteInfoArea = true

        var companyData = this.getCompanyFromId(this.l_newAdditionalRouteId.substr(0, 1), this.l_companyMasterList)
        var collectionData = this.getCollectionTypeFromId(this.l_newAdditionalRouteId.substr(3, 1), companyData)
        // companyNoはcompanyMaster.dataNo（0〜9）。旧体系の「1=車両番号入りルートID」の特別扱いは行わない
        var weekdayData = this.getWeekdayDataFromId(this.l_newAdditionalRouteId.substr(1, 1), this.l_newAdditionalRouteId.substr(2, 1), companyData.garbagetype, collectionData.collectionId)
        var carnumber = ""
        var routeNumber = this.l_newAdditionalRouteId.substr(4, 1)

        this.l_newAdditionalRouteInfo.garbageType = (companyData.garbagetype == "HouseholdGarbage" ? "家庭ごみ" : "資源ごみ")
        this.l_newAdditionalRouteInfo.companyId = companyData.companyId
        this.l_newAdditionalRouteInfo.company = companyData.companyName
        this.l_newAdditionalRouteInfo.carnumber = carnumber
        if (companyData == "0") {
          this.l_newAdditionalRouteInfo.weekday = weekdayData.weekdayJa
          this.l_newAdditionalRouteInfo.weekdayType = weekdayData.weekdayTypaJa

        } else if (companyData == "1") {
          this.l_newAdditionalRouteInfo.weekday = ""
          this.l_newAdditionalRouteInfo.weekdayType = ""

        } else {
          this.l_newAdditionalRouteInfo.weekday = weekdayData.weekdayJa
          this.l_newAdditionalRouteInfo.weekdayType = weekdayData.weekdayTypaJa

        }
        this.l_newAdditionalRouteInfo.collectionType = collectionData.collectionType
        this.l_newAdditionalRouteInfo.number = routeNumber

      } else {
        this.l_newAdditionalRouteInfoArea = false
        this.l_newAdditionalRouteInfo.error = "5桁の数字で入力してください"
      }

      if (this.l_routeRegisterProcessing || this.l_routeRegisterCompleted) return ret

      if (this.l_routeIdListData.some((data) => {
        return (data == this.l_newAdditionalRouteId);
      })) {
        this.l_routeRegisterItIsAlreadyExist = true
      }
      else {
        this.l_routeRegisterItIsAlreadyExist = false
      }

      return ret
    }
  },
  mounted: async function () {
    console.log('RouteMapModule mounted - starting initialization');
    // 企業名の解決用。地図の初期化を待たせないよう並行して取得する
    this.fetchCompanyMasterList().then(list => { this.l_companyMasterList = list });
    //this.l_stationListGeoJSON = geojson_household;
    try {
      // 認証情報の取得を最初に行う（オフライン時に無期限で固まらないようタイムアウトを設ける）
      this.credentials = await withTimeout(Auth.currentCredentials(), 10000);
    } catch (error) {
      console.error('Failed to fetch credentials:', error);
      // 認証エラーでも地図は初期化する
    }

    try {
      // Call Refresh Credentials
      await this.refreshCredentials();
    } catch (error) {
      console.error('Failed to refresh credentials:', error);
    }

    // Create Map Object
    console.log('Creating map objects...');
    try {
      this.l_mapobject = this.mapCreate('routemap');
      console.log('Main map created successfully:', this.l_mapobject);
      console.log('Main map created successfully');
    } catch (error) {
      console.error('Failed to create main map:', error);
    }

    try {
      this.l_mapHistoryobject = this.mapCreate('routeHistoryMap');
      console.log('History map created successfully');
    } catch (error) {
      console.error('Failed to create history map:', error);
    }

    console.log('RouteMapModule initialization completed');
  },
  methods: {
    // Common Function ============================
    refreshRoute() {
      this.handleRefreshRoute()
    },

    // Accordion control methods for route history
    toggleHistoryAccordion(accordionId) {
      if (this.activeHistoryAccordionId === accordionId) {
        this.activeHistoryAccordionId = null; // Close if already open
      } else {
        this.activeHistoryAccordionId = accordionId; // Open new accordion
      }
    },

    isHistoryAccordionOpen(accordionId) {
      return this.activeHistoryAccordionId === accordionId;
    },

    // Update Credentials (Amplify v5.3.12対応)
    refreshCredentials: async function () {
      try {
        // オフライン時に無期限で固まらないようタイムアウトを設ける
        this.credentials = await withTimeout(Auth.currentCredentials(), 10000);

        // 次の認証更新をスケジュール
        setTimeout(this.refreshCredentials, this.credentials.expiration - new Date());
      } catch (error) {
        console.error('Error refreshing credentials:', error);
        // エラーが発生した場合は5分後に再試行
        setTimeout(this.refreshCredentials, 5 * 60 * 1000);
      }
    },
    getLoadingFullScreenState() {
      return this.l_fullscreen_overlay
    },
    enableLoadingFullScreenState() {
      this.l_fullscreen_overlay = true
    },
    disableLoadingFullScreenState() {
      this.l_fullscreen_overlay = false
    },
    // Get Trash Image
    // companyId: companyMaster.dataNo(0〜9)。家庭ごみは収集状況に関わらず企業別配色アイコンを返す(ユーザー要望によりEmpty/Fullで区別しない)
    getTrashImage(status, type, collectionType, companyId) {
      var image = 'household_empty_image'
      if (type == "HouseholdGarbage") {
        image = this.householdFullCompanyImageMapping[companyId] || 'household_full_image';
      } else {
        if (status == "Empty") {
          image = 'recycle_empty_image';
        } else if (collectionType == "回収") {
          image = 'recycle_full_image';
        } else {
          image = 'recycle_noready_image'
        }
      }
      return image
    },
    showMoreHistoryData: async function (id) {
      await this.getRouteHistoryDataWrapper(id, this.l_routeHistoryLastId, 'add')
    },
    // Geo Resource Function ============================
    showRouteData: async function (id, data, list) {
      this.l_routeIdListData = list
      if (data != undefined) {
        this.l_routeDataReferenceJSON = data
      }

      await this.getRouteHistoryDataWrapper(id, '', 'new')
      if (id != this.l_selectedRouteId) {
        this.$root.$emit('bv::hide::collapse', 'routehistlist-accordion')
      }
      this.hideHistoryRouteData();
      this.hideHistoryStationData();
      // Requested From Route List then Reference Option Enabled
      this.l_refroute_display_enable = true;

      var routedata = {};
      routedata = data.routedata
      var layerid = id + '-refroutes';
      var sourceid = id;

      this.l_layer_current_refroute_id = layerid
      this.l_source_current_refroute_id = sourceid
      this.l_selectedRouteId = id;

      this.l_mapobject.addSource(sourceid, {
        'type': 'geojson',
        'data': routedata
      });

      this.l_mapobject.addLayer({
        'id': layerid,
        'type': 'line',
        'source': sourceid,
        'layout': {
          'line-join': 'round',
          'line-cap': 'round',
        },
        'paint': {
          'line-color': '#FFB11B',
          'line-width': 5
        }
      });

      // Calc Fitbounds and Center Point By Station Locations
      var route_lonlatlist = routedata.features[0].geometry.coordinates;

      this.l_mapobject.setZoom(this.zoom);
      this.l_mapobject.setCenter(this.centerlatlon);

      // Set Marker
      var start_lonlat = route_lonlatlist.slice(-1)[0];
      var start_marker = new maplibregl.Marker({ color: "#1E7C3C" })
        .setLngLat(start_lonlat)
        .addTo(this.l_mapobject);
      this.l_marker_current_start_point = start_marker;

      var end_lonlat = route_lonlatlist[0];
      var end_marker = new maplibregl.Marker({ color: "#434343" })
        .setLngLat(end_lonlat)
        .addTo(this.l_mapobject);
      this.l_marker_current_end_point = end_marker;
    },
    hideCurrentRouteData() {
      if (this.l_mapobject.getLayer(this.l_layer_current_refroute_id)) this.l_mapobject.removeLayer(this.l_layer_current_refroute_id);
      if (this.l_mapobject.getSource(this.l_source_current_refroute_id)) this.l_mapobject.removeSource(this.l_source_current_refroute_id);

      if (this.l_marker_current_start_point != null) { this.l_marker_current_start_point.remove() }
      if (this.l_marker_current_end_point != null) { this.l_marker_current_end_point.remove() }
    },
    showCurrentStationData(id, data, type, collectionType) {
      this.l_selecteGarbageType = type
      this.l_selecteCollectType = collectionType
      // routeIdの先頭1桁がcompanyMaster.dataNoに対応する企業No
      var companyId = String(id).substr(0, 1)
      var FullStations = data.filter(function (item, index) {
        if (item.properties.status == 'Full' && item.properties.type == type) {
          return true
        }
      }.bind(this));
      this.l_currentFullStationLayerData = { id: id, state: 'Full', type: type, collectionType: collectionType }
      this.addStationLayers(this.l_currentFullStationLayerData.id,
        this.l_currentFullStationLayerData.state,
        this.l_currentFullStationLayerData.type,
        this.l_currentFullStationLayerData.collectionType,
        FullStations,
        this.l_mapobject,
        companyId)

      var EmptyStations = data.filter(function (item, index) {
        if (item.properties.status == 'Empty' && item.properties.type == type) {
          return true
        }
      }.bind(this));

      this.l_currentEmptyStationLayerData = { id: id, state: 'Empty', type: type, collectionType: collectionType }
      this.addStationLayers(this.l_currentEmptyStationLayerData.id,
        this.l_currentEmptyStationLayerData.state,
        this.l_currentEmptyStationLayerData.type,
        this.l_currentFullStationLayerData.collectionType,
        EmptyStations,
        this.l_mapobject,
        companyId)
    },
    showHitoryStationData(id, data, type, collectionType) {
      // routeIdの先頭1桁がcompanyMaster.dataNoに対応する企業No
      var companyId = String(id).substr(0, 1)
      var FullStations = data.filter(function (item, index) {
        if (item.properties.status == 'Full' && item.properties.type == type) {
          return true
        }
      }.bind(this));
      this.l_historyFullStationLayerData = { id: id, state: 'Full', type: type, collectionType: collectionType }
      this.addStationLayers(this.l_historyFullStationLayerData.id,
        this.l_historyFullStationLayerData.state,
        this.l_historyFullStationLayerData.type,
        this.l_historyFullStationLayerData.collectionType,
        FullStations,
        this.l_mapHistoryobject,
        companyId)

      var EmptyStations = data.filter(function (item, index) {
        if (item.properties.status == 'Empty' && item.properties.type == type) {
          return true
        }
      }.bind(this));

      this.l_historyEmptyStationLayerData = { id: id, state: 'Empty', type: type, collectionType: collectionType }
      this.addStationLayers(this.l_historyEmptyStationLayerData.id,
        this.l_historyEmptyStationLayerData.state,
        this.l_historyEmptyStationLayerData.type,
        this.l_historyFullStationLayerData.collectionType,
        EmptyStations,
        this.l_mapHistoryobject,
        companyId)
    },
    hideCurrentStationData() {
      if (this.l_currentFullStationLayerData != null && this.l_currentEmptyStationLayerData != null) {
        this.removeStationLayers(this.l_currentFullStationLayerData, this.l_mapobject)
        this.removeStationLayers(this.l_currentEmptyStationLayerData, this.l_mapobject)
      }
    },
    hideHistoryStationData() {
      if (this.l_historyFullStationLayerData != null && this.l_historyEmptyStationLayerData != null) {
        this.removeStationLayers(this.l_historyFullStationLayerData, this.l_mapHistoryobject)
        this.removeStationLayers(this.l_historyEmptyStationLayerData, this.l_mapHistoryobject)
      }
      for (var i in this.l_popUpListObject) {
        var popup = this.l_popUpListObject[i]
        popup.remove()
      }
      this.l_popUpListObject = []
    },
    handleTabChange(tabIndex) {
      console.log('l_mapobject at tab change:', this.l_mapobject); // 値を確認
      {
        if (tabIndex === this.TAB_INDEX.ROUTE_HISTORY) {
          { // ルート履歴タブのインデックス
            this.listenHistoryTabClick()
          }
        } else if (tabIndex === this.TAB_INDEX.ROUTE) {
          { // 参考ルートタブのインデックス
            this.listenCurrentTabClick()
          }
        }
      }
    },

    //ルート履歴表示不正、回避実装
    listenCurrentTabClick: async function () {
      await this.$nextTick()
      if (this.l_mapobject) {
        await this.listenTabClick(this.l_mapobject)
      } else {
        console.warn('l_mapobject is not available')
      }
    },

    //ルート履歴表示不正、回避実装
    listenHistoryTabClick: async function () {
      await this.$nextTick()
      if (this.l_mapHistoryobject) {
        console.log('history mapobject available:', this.l_mapHistoryobject)
        await this.listenTabClick(this.l_mapHistoryobject)
      } else {
        console.warn('history mapobject is undefined')
      }
    },
    listenTabClick(mapobject) {
      this.l_clickCurrentMapObject = mapobject
      mapobject.resize()
    },
    // Station Click Listener
    listenStationClick(e) {
      var coordinates = e.features[0].geometry.coordinates.slice();
      var station = e.features[0].properties;

      // Ensure that if the map is zoomed out such that
      // multiple copies of the feature are visible, the
      // popup appears over the copy being pointed to.
      while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
        coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
      }
      var stationStatus = this.getConvertedStationStatus(station.type, station.status)
      var popup = new maplibregl.Popup()
        .setLngLat(coordinates)
        .setHTML(
          '管理番号 : ' + station.name + '<br>' +
          // 'ID : ' + station.id + '<br>' +
          '種別 : ' + stationStatus.type + '<br>' +
          '回収状態 : ' + stationStatus.status + '<br>' +
          '最終更新 : ' + station.timestamp
        )
        .addTo(this.l_clickCurrentMapObject);
      this.l_popUpListObject.push(popup)
    },
    // Geo Resource Function ============================
    toggleHistoryRouteSymbolData() {
      if (this.l_layer_current_histroute_symbol_id != '') {
        const visibiliy = this.l_mapHistoryobject.getLayoutProperty(this.l_layer_current_histroute_symbol_id, 'visibility')
        if (visibiliy == 'visible') {
          this.l_mapHistoryobject.setLayoutProperty(this.l_layer_current_histroute_symbol_id, 'visibility', 'none')
        } else {
          this.l_mapHistoryobject.setLayoutProperty(this.l_layer_current_histroute_symbol_id, 'visibility', 'visible')
        }
      }
    },
    showHistoryRouteData: async function (event, index) {
      this.enableLoadingFullScreenState()
      var routeid = event.routeid
      var date = event.date
      var carnumber = event.vehicleId

      this.hideHistoryRouteData();
      this.hideHistoryStationData()

      await this.getRouteHistoryDataDetailsWrapper(routeid, carnumber, date, index)

      // Requested From Route List then Reference Option Enabled
      this.l_histroute_display_enable = true;

      this.l_routeDataActualJSON_index = index

      var routedata = {};
      var routesymboldata = [];
      routedata = this.l_routeDataActualJSON[index].routedata
      routesymboldata = this.l_routeDataActualJSON[index].routesymboldata

      // APIエラー等でルートデータが取得できなかった場合は描画をスキップ
      if (!routedata || !routedata.features || routedata.features.length === 0 ||
          !routedata.features[0].geometry || !routedata.features[0].geometry.coordinates) {
        console.warn('Route data is empty or invalid, skipping display');
        this.l_route_regist_enable = false;
        this.disableLoadingFullScreenState()
        return;
      }
      var id = routeid + "-" + index
      var layerid_line = id + '-histroutes';
      var layerid_symbol = id + '-histroutes_symbol';

      this.l_layer_current_histroute_id = layerid_line
      this.l_source_current_histroute_id = layerid_line
      this.l_layer_current_histroute_symbol_id = layerid_symbol
      this.l_source_current_histroute_symbol_id = layerid_symbol
      this.l_selectedHisoryRouteId = id;

      this.l_mapHistoryobject.addSource(layerid_line, {
        'type': 'geojson',
        'data': routedata
      });

      this.l_mapHistoryobject.addSource(layerid_symbol, {
        'type': 'geojson',
        'data': routesymboldata
      });

      this.l_mapHistoryobject.addLayer({
        'id': layerid_line,
        'type': 'line',
        'source': layerid_line,
        'layout': {
          'line-join': 'round',
          'line-cap': 'round'
        },
        'paint': {
          'line-color': '#1E7C3C',
          'line-width': 5
        }
      });

      this.l_mapHistoryobject.addLayer({
        'id': layerid_symbol,
        'type': 'symbol',
        'source': layerid_symbol,
        'layout': {
          'visibility': (this.isSymbolView ? 'visible' : 'none'),
          "text-field": ['get', 'name'],
          "text-font": ["Fira GO Map Bold"],
          "text-size": 16,
          "text-anchor": "left",
        }
      });

      // Calc Fitbounds and Center Point By Station Locations
      var route_lonlatlist = routedata.features[0].geometry.coordinates;
      console.log('route_lonlatlist.length:', route_lonlatlist.length)
      console.log('l_route_regist_enable:', this.l_route_regist_enable)
      console.log("this.l_routeDataActualJSON[index].routedata",this.l_routeDataActualJSON[index].routedata)
      console.log('ああああああああああああああああああああ:', this.l_routeDataActualJSON[index].routedata.features[0].geometry.coordinates);
      this.l_mapHistoryobject.setZoom(this.zoom);
      this.l_mapHistoryobject.setCenter(this.centerlatlon);

      if (route_lonlatlist.length > 0) {
        this.l_route_regist_enable = true;

        // Set Marker
        var start_lonlat = route_lonlatlist.slice(-1)[0];
        var start_marker = new maplibregl.Marker({ color: "#1E7C3C" })
          .setLngLat(start_lonlat)
          .addTo(this.l_mapHistoryobject);
        this.l_marker_hist_start_point = start_marker;

        var end_lonlat = route_lonlatlist[0];
        var end_marker = new maplibregl.Marker({ color: "#434343" })
          .setLngLat(end_lonlat)
          .addTo(this.l_mapHistoryobject);
        this.l_marker_hist_end_point = end_marker;
      } else {
        this.l_route_regist_enable = false;
      }
      this.disableLoadingFullScreenState()
      //ステーションの表示
      this.showHitoryStationData(routeid, this.l_stationDataActualJSON, this.l_selecteGarbageType, this.l_selecteCollectType)

    },
    hideHistoryRouteData() {
      if (this.l_mapHistoryobject.getLayer(this.l_layer_current_histroute_id)) this.l_mapHistoryobject.removeLayer(this.l_layer_current_histroute_id);
      if (this.l_mapHistoryobject.getSource(this.l_source_current_histroute_id)) this.l_mapHistoryobject.removeSource(this.l_source_current_histroute_id);
      if (this.l_mapHistoryobject.getLayer(this.l_layer_current_histroute_symbol_id)) this.l_mapHistoryobject.removeLayer(this.l_layer_current_histroute_symbol_id);
      if (this.l_mapHistoryobject.getSource(this.l_source_current_histroute_symbol_id)) this.l_mapHistoryobject.removeSource(this.l_source_current_histroute_symbol_id);

      if (this.l_marker_hist_start_point != null) { this.l_marker_hist_start_point.remove() }
      if (this.l_marker_hist_end_point != null) { this.l_marker_hist_end_point.remove() }
    },
    initRouteId() {
      this.l_newAdditionalRouteId = ""
    },
    // GUI Handler ================================
    // Handle Show History
    handlerHistoryRouteDisplay(event, index) {
      this.showHistoryRouteData(event, index)
    },
    // Handle Reference Route Option
    handlerReferenceRouteDisplayOption(event) {
      if (event == true) {
        // Show Current Reference Route
        this.showRouteData(this.l_selectedRouteId, this.l_routeDataReferenceJSON);
      } else {
        // Hide Current Reference Route
        this.hideCurrentRouteData();
      }
    },
    handlerShowMoerRouteHistoryDispleay(event) {
      this.showMoreHistoryData(this.l_selectedRouteId)
    },
    // Create Map Object
    mapCreate: function (container) {
      console.log(`mapCreate called for container: ${container}`);
      // コンテナ要素の存在確認
      const containerElement = document.getElementById(container);
      if (!containerElement) {
        console.error(`Container element with id '${container}' not found`);
        return null;
      }
      console.log(`Container element found:`, containerElement);
      // Initially Center Point Set As Muroran City Hall
      // Loading Maps
      try {
        const map = new maplibregl.Map({
          container: container,
          style: 'Honeycomb_Here_Explore',
          center: this.centerlatlon,
          zoom: this.zoom,
          bearing: 0,
          pitch: 0,
          transformRequest: this.transformRequest,
        });

        console.log(`MapLibre GL map created for ${container}`);

        map.addControl(new maplibregl.NavigationControl(), "top-right");
        map.addControl(new maplibregl.FullscreenControl());

        map.once('styledata', function () {
          console.log(`Style data loaded for ${container}`);
          for (var layer of map.style.stylesheet.layers) {
            if (map.style._serializedLayers[layer.id].layout &&
              map.style._serializedLayers[layer.id].layout['text-field'] &&
              map.style._serializedLayers[layer.id].layout['text-field'] === '{_name_global}') {
              map.setLayoutProperty(layer.id, 'text-field', '{_name_local}');
            }
          }
        });

        function toggleSidebar(id) {
          var elem = document.getElementById(id);
          // DOM要素の存在チェック
          if (!elem) {
            console.warn(`Element with id '${id}' not found`);
            return;
          }

          var classes = elem.className.split(' ');
          var collapsed = classes.indexOf('collapsed') !== -1;

          var padding = {};

          if (collapsed) {
            // Remove the 'collapsed' class from the class list of the element, this sets it back to the expanded state.
            classes.splice(classes.indexOf('collapsed'), 1);

            padding[id] = 300; // In px, matches the width of the sidebars set in .sidebar CSS class
            map.easeTo({
              padding: padding,
              duration: 1000 // In ms, CSS transition duration property for the sidebar matches this value
            });
          } else {
            padding[id] = 0;
            // Add the 'collapsed' class to the class list of the element
            classes.push('collapsed');

            map.easeTo({
              padding: padding,
              duration: 1000
            });
          }

          // Update the class list on the element
          elem.className = classes.join(' ');
        }

        map.on('load', async function () {
          toggleSidebar('left')
          await map.loadImage(household_empty_image, (error, image) => {
            map.addImage('household_empty_image', image);
          })
          await map.loadImage(household_full_image, (error, image) => {
            map.addImage('household_full_image', image);
          })
          await map.loadImage(recycle_empty_image, (error, image) => {
            map.addImage('recycle_empty_image', image);
          })
          await map.loadImage(recycle_full_image, (error, image) => {
            map.addImage('recycle_full_image', image);
          })
          await map.loadImage(recycle_noready_image, (error, image) => {
            map.addImage('recycle_noready_image', image);
          })
          await map.loadImage(household_full_blue_image, (error, image) => {
            map.addImage('household_full_blue_image', image);
          })
          await map.loadImage(household_full_green_image, (error, image) => {
            map.addImage('household_full_green_image', image);
          })
          await map.loadImage(household_full_red_image, (error, image) => {
            map.addImage('household_full_red_image', image);
          })
          await map.loadImage(household_full_yellow_image, (error, image) => {
            map.addImage('household_full_yellow_image', image);
          })
          await map.loadImage(household_full_purple_image, (error, image) => {
            map.addImage('household_full_purple_image', image);
          })

        }.bind(this));

        return map;

      } catch (error) {
        console.error(`Failed to create map for ${container}:`, error);
        return null;
      }
    },
    // Amazon Location Maps設定
    transformRequest: function (url, resourceType) {
      if (resourceType === 'Style' && !url.includes('://')) {
        // スタイル設定
        url = `https://maps.geo.ap-northeast-1.amazonaws.com/maps/v0/maps/${url}/style-descriptor`
      }
      if (url.includes('amazonaws.com')) {
        if (!this.credentials) {
          return { url };
        }

        return {
          url: Signer.signUrl(url, {
            access_key: this.credentials.accessKeyId,
            secret_key: this.credentials.secretAccessKey,
            session_token: this.credentials.sessionToken,
          }),
        }
      }
      return { url }
    },
    addStationLayers(id, state, type, collectionType, data, mapobject, companyId) {
      var layerid = id + '-stations' + state + type;
      var sourceid = id + state + type;
      var collection = {
        type: "FeatureCollection",
        features: data
      }
      if (mapobject.getSource(sourceid)) { }
      else {
        mapobject.addSource(sourceid, {
          type: 'geojson',
          data: collection,
        });
      }

      if (mapobject.getLayer(layerid)) { }
      else {
        mapobject.addLayer({
          id: layerid,
          type: 'symbol',
          source: sourceid,
          layout: {
            "icon-image": this.getTrashImage(state, type, collectionType, companyId),
            "icon-allow-overlap": true
          }
        });
      }

      this.l_clickCurrentMapObject = mapobject
      mapobject.off('click', layerid, this.listenStationClick);
      mapobject.on('click', layerid, this.listenStationClick);

    },
    removeStationLayers(param, mapobject) {
      var layerid = param.id + '-stations' + param.state + param.type;
      var sourceid = param.id + param.state + param.type;
      if (mapobject.getLayer(layerid)) mapobject.removeLayer(layerid);
      if (mapobject.getSource(sourceid)) mapobject.removeSource(sourceid);
    },
    pushRouteHistoryLists(dataPart, id) {
      var startTimestamp = dataPart.collectStartDate.replaceAll("/", "-")
      // 修正[CLAS-1262] UTC→JST変換
      var dateData_local = moment.utc(startTimestamp).local().format('YYYY/MM/DD')
      var dateData = dateData_local.split(' ')[0]

      var startTimestamp_local = moment.utc(startTimestamp).local().format('YYYY/MM/DD HH:mm:ss')
      var startTimeData = startTimestamp_local.split(' ')[1]

      var finishedTimestamp = dataPart.collectEndDate.replaceAll("/", "-")
      var finishedTimestamp_local = moment.utc(finishedTimestamp).local().format('YYYY/MM/DD HH:mm:ss')
      var finishedTimeData = finishedTimestamp_local.split(' ')[1]

      var durationData = dataPart.Duration
      var companyData = dataPart.companyName
      var vehicleStatus = (dataPart.tripStatus == 0) ? 'Active' : 'InActive'
      var stationTotal = 1000
      var stationCurrent = dataPart.stationsCleared
      var vehicleIdData = dataPart.vehicleId

      var part = {
        routeid: id,
        date: dateData,
        startAt: startTimeData,
        finishedAt: finishedTimeData,
        duration: durationData,
        company: companyData,
        status: vehicleStatus,
        stationTotal: stationTotal,
        stationCurrent: stationCurrent,
        vehicleId: vehicleIdData,
        routedata: {},
        routesymboldata: []
      }
      this.l_routeDataActualJSON.push(part)
    },
    addRouteHistoryLists(data, id) {
      for (var i in data) {
        this.pushRouteHistoryLists(data[i], id)
      }
    },
    updateRouteHistoryLists(data, id) {
      this.l_routeDataActualJSON = [];
      for (var i in data) {
        this.pushRouteHistoryLists(data[i], id)
      }
    },
    // Interface Wrapper
    // garbageRouteRecordRequest
    getRouteHistoryDataWrapper: async function (id, routeHistoryId, cmd) {
      this.l_routeHistoryProcessing = true

      const reqdata = {
        headers: {
          "Authorization": this.$store.getters.user.signInUserSession.idToken.jwtToken
        },
        params: {
          routeId: id,
          routeHistoryId: routeHistoryId
        }
      };
      await axios.get(this.createAPI("routemanagement/garbagerouterecordrequest"), reqdata)
        .then(response => {
          var data = response.data.routeHistory
          if (cmd == 'new') {
            this.updateRouteHistoryLists(data, id)
          } else if (cmd == 'add') {
            this.addRouteHistoryLists(data, id)
          }
          this.l_routeHistoryLastId = response.data.routeHistoryId
          if (data.length == 0) {
            var title = "ルート履歴リスト取得結果"
            var msg = "ルート履歴が見つかりませんでした"
            this.showErrorMessageToast(
              title,
              msg,
              'info'
            );
          } else {
            var title = "ルート履歴リスト取得結果"
            var msg = data.length + " 件のルート履歴が見つかりました"
            this.showErrorMessageToast(
              title,
              msg,
              'info'
            );
          }
        })
        .catch(error => {
          console.log(error)
          var title = "ルート履歴リスト取得エラー"
          var msg = "対象ルート(" + id + ")の履歴が見つかりませんでした"
          this.showErrorMessageToast(
            title,
            msg,
            'danger'
          );
          this.updateRouteHistoryLists([], id)
          this.l_routeHistoryLastId = ""
        })
      this.l_routeHistoryProcessing = false
    },
    // Route History Details
    getRouteHistoryDataDetailsWrapper: async function (routeid, carnumber, date, index) {
      const reqdata = {
        headers: {
          "Authorization": this.$store.getters.user.signInUserSession.idToken.jwtToken
        },
        params: {
          routeid: routeid,
          carnumber: carnumber,
          date: date
        }
      };
      await axios.get(this.createInternalAPI("routehistory/detail"), reqdata)
        .then(response => {
          console.log('response.data:', response.data);
console.log('routeHistory:', response.data.routeHistory);
          var coord = []
          var list = response.data.routeHistory
          var routesymboldata = []
          for (var i in list) {
            var timestap = list[i].timestamp.replaceAll("/", "-")
            var timestap_local = moment.utc(timestap).local().format('HH:mm:ss')
            var routesymbol = {
              type: "Feature",
              properties: {
                name: timestap_local //表記は後で変更
              },
              geometry: {
                type: "Point",
                coordinates: list[i].lonlat
              }

            }
            routesymboldata.push(routesymbol)
            coord.push(list[i].lonlat)
          }
          console.log('coord after loop:', coord);
          var routes = {
            type: "FeatureCollection",
            features: [
              {
                type: "Feature",
                geometry: {
                  type: "LineString",
                  coordinates: coord
                }
              }
            ]
          }
          this.l_routeDataActualJSON[index].routedata = routes
          this.l_routeDataActualJSON[index].routesymboldata = {
            type: "FeatureCollection",
            features: routesymboldata
          }

          //ステーション情報の取得
          var routeStation = []
          var station_list = response.data.stStatus
          for (var i in station_list) {
            var lastupdatets = station_list[i].last_update.replaceAll("/", "-")
            var lastUpdate = moment.utc(lastupdatets).local().format('YYYY/MM/DD HH:mm:ss')

            var latlon = [station_list[i].longitude, station_list[i].latitude]
            var station = {
              type: "Feature",
              properties: {
                name: station_list[i].stName,
                id: station_list[i].controlNumber,
                type: (String(station_list[i].garbageType) == "0") ? 'HouseholdGarbage' : 'RecycleGarbage',
                status: (String(station_list[i].collectStatus) == "0") ? 'Full' : 'Empty',
                timestamp: lastUpdate,
                today: false
              },
              geometry: {
                type: "Point",
                coordinates: latlon
              }
            }
            routeStation.push(station)
          }
          this.l_stationDataActualJSON = routeStation

        })
        .catch(error => {
          console.log("USE LOCAL DUMMY")
          console.log(error)
          console.log(error)
          var title = "ルート履歴詳細情報取得エラー"
          var msg = "指定した履歴のルートが見つかりませんでした"
          this.showErrorMessageToast(
            title,
            msg,
            'danger'
          );
        })

    },
    registerRouteDetaWrapper(id) {
      this.l_routeRegisterProcessing = true

      var company = this.getCompanyFromId(id.substr(0, 1), this.l_companyMasterList)
      var garbagetype = (company.garbagetype == "HouseholdGarbage" ? "1" : "2")

      var coordlist = this.l_routeDataActualJSON[this.l_routeDataActualJSON_index].routedata.features[0].geometry.coordinates
      var startCoord = []
      var arrivalCoord = []
      var wayPoints = []
      for (var i in coordlist) {
        if (i == 0) {
          startCoord.push({
            latitude: coordlist[i][1],
            longitude: coordlist[i][0]
          })
        } else if (i == (coordlist.length - 1)) {
          arrivalCoord.push({
            latitude: coordlist[i][1],
            longitude: coordlist[i][0]
          })
        } else {
          wayPoints.push({
            latitude: coordlist[i][1],
            longitude: coordlist[i][0]
          })
        }
      }

      var stStatus = []
      var station = this.l_stationDataActualJSON
      for (var i in station) {
        stStatus.push({
          stationId: String(station[i].properties.id),
          stName: station[i].properties.name
        })
      }

      const hdrdata = {
        headers: {
          "Authorization": this.$store.getters.user.signInUserSession.idToken.jwtToken
        },
      };
      const paramdata = {
        routeId: id,
        garbageType: garbagetype,
        startPosition: startCoord,
        arrivalPosition: arrivalCoord,
        waypoint: wayPoints,
        stStatus: stStatus
      };
      axios.post(this.createAPI("routemanagement/routeregistrequest"), paramdata, hdrdata)
        .then(response => {
          this.l_routeRegisterProcessing = false
          this.l_routeRegisterCompleted = true
          this.refreshRoute()
        })
        .catch(error => {
          this.l_routeRegisterProcessing = false
          this.l_routeRegisterCompleted = true

          console.log("ERROR")
          console.log(error)
        })
    },
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+JP&display=swap');

#routemap {
  z-index: 0;
  height: calc(100vh - 6rem);
}

#routeHistoryMap {
  z-index: 0;
  height: calc(100vh - 6rem);
}

.maplibregl-canvas {
  height: 100% !important;
  width: 100% !important;
}

.newmodal {
  font-family: 'Noto Sans JP', sans-serif;
  -webkit-font-smoothing: subpixel-antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.rounded-rect {
  background: white;
  border-radius: 10px;
  box-shadow: 0 0 50px -25px black;
}

.flex-center {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
}

.input-inputLabel {
  text-align: right;
}


.flex-center.left {
  left: 0px;
}

.sidebar-content {
  position: absolute;
  width: 95%;
  height: 95%;
  font-family: 'Noto Sans JP', sans-serif;
  -webkit-font-smoothing: subpixel-antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.sidebar {
  transition: transform 1s;
  z-index: 1;
  width: 400px;
  height: 100%;
}

.list-group {
  height: calc(100vh - 11rem);
  overflow-y: auto;
}

::-webkit-scrollbar {
  width: 10px;
}

::-webkit-scrollbar-track {
  background: #fff;
  border: none;
  border-radius: 10px;
  box-shadow: inset 0 0 2px #777;
}

::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 10px;
  box-shadow: none;
}

.cursor-pointer {
  cursor: pointer;
}
</style>
